import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-55" data-mp="1bmlmp7radxkh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-56" data-mp="1gk5aozdsdopm">
        <SectionHeading eyebrow="Lo que más nos preguntan" data-id="element-57" data-mp="249g3nuowaet7">
          Preguntas frecuentes
        </SectionHeading>

        <div className="mt-10 space-y-3" data-id="element-58" data-mp="28bb6j3mh5093">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-[var(--violet)]/40 bg-[#0d0819]" data-id="element-59" data-mp="1uiv5g8d4vcat" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-[var(--violet)]/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--lilac)]/40" data-id="element-60" data-mp="2n70sx2vknfec">
                  <span className="font-semibold text-[var(--cream)]" data-id="element-61" data-mp="1eldaoemg558m">
                    {faq.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-[var(--lilac)]" aria-hidden="true" data-id="element-62" data-mp="19skam41xal2v" /> : <PlusIcon className="h-5 w-5 shrink-0 text-[var(--lilac)]" aria-hidden="true" data-id="element-63" data-mp="1jmavz02r6fec" />}
                </button>
                {isOpen && <p className="px-5 pb-5 text-white/70" data-id="element-64" data-mp="35yido56n1ju">{faq.answer}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}